<template>
	<div class="app-main order-detail-page">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="14" style="display:flex;line-height:40px">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
				<span class="djs-bar" v-if="countDown">倒计时：{{countDown}}</span>
			</el-col>
			<el-col :span="10" class="app-main-header-btns">
				<el-button size="small" type="primary" v-show="checkRole('gys_role') && xjOrder && xjOrder.gysOrderState==1" @click="handleCy">参与 </el-button>
				<el-button size="small" type="primary" v-show="checkRole('gys_role') && xjOrder && xjOrder.gysOrderState==1" @click="handleFq">放弃 </el-button>
				<el-button size="small" type="primary" v-show="checkRole('cgy_role') && xjOrder && xjOrder.orderState==2" @click="handleJsxu">整单结束询价 </el-button>
				<el-button size="small" type="primary" v-show="checkRole('cgy_role') && xjOrder && xjOrder.orderState==4 && (!xjOrder.auditStatus || xjOrder.auditStatus == 2) && xjOrder.createUser == userInfo.id" @click="startAuditOrder">发起中标审批 </el-button>
				<el-button size="small" type="primary" v-show="(checkRole('cgy_role') || checkRole('pw') || checkRole('leader'))&& xjOrder && xjOrder.orderState==4 && xjOrder.createUser != userInfo.id && xjOrder.auditStatus == 1" @click="openAuditOrder">审批 </el-button>
				<el-button size="small" type="primary" v-show="checkRole('leader') && xjOrder && xjOrder.orderState==6 " @click="sendTenderMsg">发送中标通知 </el-button>
				<!--
        <el-button size="small" type="primary" v-show="checkRole('CBS2025011003') && xjOrder && xjOrder.orderState==7 && xjOrder.generatedOrder == '否'" @click="creatCGOrder">生成采购订单</el-button>
				<el-button size="small" type="primary" v-if="!auditShow && !checkRole('gys_role')" @click="exportTenderWord">中标结果导出 </el-button>
        -->
				<el-button size="small" type="primary" v-if="!auditShow" @click="$router.back(-1)">返回 </el-button>
			</el-col>
		</el-row>
		<el-steps :active="lastAudit" finish-status="success" v-if="auditShow" simple style="margin: 10px 0">
			<el-step title="采购组" ></el-step>
			<el-step title="评委组" ></el-step>
      <!--<el-step title="副经理" ></el-step>-->
			<el-step title="定标发布" ></el-step>
      <!--<el-step title="董事长" ></el-step>-->
			<el-step title="完成" ></el-step>
		</el-steps>
		<div class="order-info-main">
			<div :class="['info-wrap',auditFlag?'has-audit-list':'']">
				<el-row class="mg-b5">
					<el-col :span="24">
						<OrderHeader :orderInfo="xjOrder"/>
					</el-col>
					<el-col :span="24">
						<el-card class="box-card" style="min-height:calc(100vh - 292px);position: relative;">
							<el-tabs v-model="activeName">
								<el-tab-pane label="物料列表" name="first" v-if="!checkRole('gys_role')" :disabled="MateriaTableIsEditTender">
									<MateriaTable v-if="hId && xjOrder" ref="MateriaTableRef" :showTenderRow="showTenderRow" @callback="MateriaTableCallback" :editTender="MateriaTableIsEditTender" :hId="hId" :orderInfo="xjOrder" pageFlag="inquiryDetail"/>
								</el-tab-pane>
								<el-tab-pane label="报价轮次" name="second" :disabled="MateriaTableIsEditTender">
									<RoundList v-if="hId && xjOrder" ref="RoundListRef" :hId="hId" :orderInfo="xjOrder" pageFlag="inquiryDetail" @callback="roundListCallback"/>
								</el-tab-pane>
								<el-tab-pane label="附件列表" name="third" :disabled="MateriaTableIsEditTender">
									<FileList v-if="hId && xjOrder" ref="FileListRef" :hId="hId" :orderInfo="xjOrder" pageFlag="inquiryDetail" />
								</el-tab-pane>
								<el-tab-pane label="报价须知" name="five" :disabled="MateriaTableIsEditTender">
									<NoticeList v-if="hId && xjOrder" ref="NoticeListRef" :hId="hId" :orderInfo="xjOrder" pageFlag="inquiryDetail" />
								</el-tab-pane>
								<el-tab-pane label="评委名单" name="fourth" :disabled="MateriaTableIsEditTender" v-if="checkRole('cgy_role') && xjOrder && xjOrder.orderState != 1 && xjOrder.orderState != 2">
									<JudgeList v-if="hId && xjOrder" ref="JudgeListRef" :hId="hId" :orderInfo="xjOrder" />
								</el-tab-pane>
							</el-tabs>
							<div class="tab-pane-btns">
								<!-- 物料部分 -->
								<el-button v-if="activeName == 'first' && xjOrder && xjOrder.orderState == 1 && checkRole('cgy_role')" size="small" type="primary" @click="addMaterial">新增物料</el-button>
								<el-button v-if="activeName == 'first' && xjOrder && xjOrder.orderState == 3 && checkRole('cgy_role') && !MateriaTableIsEditTender" size="small" type="primary" @click="editTender(3)">编辑指定中标供方</el-button>
								<el-button v-if="activeName == 'first' && xjOrder && xjOrder.orderState == 3 && checkRole('cgy_role') && MateriaTableIsEditTender" size="small" type="primary" @click="editTender(4)">保存中标数据</el-button>
								<el-button v-if="activeName == 'first' && xjOrder && xjOrder.orderState == 3 && checkRole('cgy_role') && MateriaTableIsEditTender" size="small" type="primary" @click="editTender(5)">取消</el-button>
								<el-button v-if="activeName == 'first' && xjOrder && xjOrder.orderState >= 4 && checkRole('cgy_role') && MateriaTableIsEditTender" size="small" type="primary" @click="editTender(5)">取消</el-button>
								<div class="show-tender-row-switch" v-if="activeName == 'first' && xjOrder && xjOrder.orderState >= 4 && checkRole('cgy_role') ">
									<span>仅显示中标行</span>
									<el-switch
										size="mini"
										v-model="showTenderRow"
										active-color="#13ce66"
										inactive-color="#999">
									</el-switch>
								</div>
								<!-- 轮次部分 -->
								<el-button v-if="activeName == 'second' && xjOrder && (( xjOrder.orderState == 1) || (isAgain && xjOrder.orderState == 2)) && checkRole('cgy_role')" size="small" type="primary" @click="addRound">新增询价轮次</el-button>
								<el-button v-if="
											activeName == 'third' && xjOrder &&
											((xjOrder.orderState == 1 && checkRole('cgy_role'))||
											(xjOrder.orderState == 2 && checkRole('cgy_role'))||
											(xjOrder.orderState == 3 && checkRole('cgy_role'))||
											(xjOrder.gysOrderState == 3 && checkRole('gys_role')))"
											size="small" type="primary" @click="addFile">新增附件</el-button>
								<!-- 报价须知部分 -->
								<el-button v-if="
											activeName == 'five' && xjOrder && xjOrder.orderState == 1 && checkRole('cgy_role')"
											size="small" type="primary" @click="addNotice">新增报价须知</el-button>
								<!-- 评委部分 -->
								<el-button v-if="activeName == 'fourth' && xjOrder && ( xjOrder.orderState == 3 || (xjOrder.orderState == 4 && (!xjOrder.auditStatus || xjOrder.auditStatus == 2) ))&& checkRole('cgy_role')" size="small" type="primary" @click="addJudge">新增评委</el-button>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
			<div class="audit-wrap" v-if="auditFlag">
				<el-card class="box-card" style="min-height:calc(100vh - 135px);position: relative;">
					<div style="padding-bottom: 20px;display: flex;align-items: center;">
						<el-divider direction="vertical"></el-divider>
						<span>审核记录</span>
					</div>
					<div class="audit-list-box">
						<div class="audit-item" v-for="(item,index) in auditList" :key="index">
							<div class="bar">
								<div class="name-box">
									<p class="name">{{item.userName}}</p>
									<p class="time">{{item.createTime}}</p>
								</div>

								<el-tag type="success" v-if="item.auditStatus == 3">通过</el-tag>
								<el-tag type="danger" v-if="item.auditStatus == 2">驳回</el-tag>
								<!-- <el-tag type="info" v-if="item.operDesc != '通过' &&  item.operDesc != '驳回'">{{item.operDesc}}</el-tag> -->
							</div>
							<div class="audit-img" v-if="item.auditSignFileUrl">
								<img :src="imgBaseUrl+item.auditSignFileUrl" />
							</div>
							<div class="bh-reson" v-if="item.auditRemark">{{item.auditRemark}}</div>
						</div>
					</div>
				</el-card>
			</div>
		</div>
		<AuditTender ref="AuditTenderRef" @callback="AuditTenderRefCallback" />
		<EditTender v-if="hId && xjOrder" ref="EditTenderRef" @callback="EditTenderRefCallback" :hId="hId" :orderInfo="xjOrder"/>
	</div>
</template>

<script>
 	// orderState 1:待询价,2:询价中,3:已结束询价待审批,4:询价审批中,5:定标审批被驳回,6:定标审批通过,7:已发布中标通知,
 	// gysOrderState // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标
	import { exportInquiryDetail,finishOrderXj,auditOrder,exportWord ,getOrderAuditListByOrderId,zhongbiaoOrderNotice,generateFinalOrder,getLastOrderState} from '@/api/srm/inquiryDetail.js'
	import { inquiryById } from '@/api/srm/inquiry.js'
	import { joinInquiry,giveUpInquiry } from '@/api/srm/inquiryUser.js'
	import OrderHeader from '../../../components/OrderHeader'
	import MateriaTable from './MateriaTable.vue'
	import RoundList from './RoundList.vue'
	import FileList from './FileList.vue'
	import NoticeList from './NoticeList.vue'
	import JudgeList from './JudgeList.vue'
	import AuditTender from './AuditTender.vue'
	import EditTender from './EditTender.vue'
	import moment from 'moment'
	import { getBaseImgUrl } from '@/utils/index'
	export default {
		name: "InquiryDetail",
		components:{
			OrderHeader,
			MateriaTable,
			RoundList,
			FileList,
			JudgeList,
			AuditTender,
			NoticeList,
			EditTender
		},
		data() {
			return {
				imgBaseUrl:getBaseImgUrl(),
				countDown:null,
				showTenderRow:false,
				auditFlag:false,
				activeName:'first',
				hId:this.$route.query.hId,
				auditShow:this.$route.query.auditShow,
				show: this.$route.query.show,
				timer: null,
				loadingInstance: undefined,
				xjOrder: null,
				drawer: false,
				fileName: '',
				dayDiff: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				isAgain: false,
				quertInfo: {
					page: 1, //当前页码
					limit: 2000, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.$route.query.hId,
					}
				},
				auditList:[],	//	审核记录
				MateriaTableIsEditTender:false,
				lastAudit:0,
			};
		},
		computed:{
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
			userInfo:function(){
				return this.$store.getters['user/user'];
			},
			percentHours:function(){
				if(Math.abs(this.hours)>0){
					return parseInt(Math.abs(this.hours)/24*100)
				}else{
					return 0
				}
			},
			percentMinutes:function(){
				if(Math.abs(this.minutes)>0){
					return parseInt(Math.abs(this.minutes)/60*100)
				}else{
					return 0
				}
			},
			percentSeconds:function(){
				if(Math.abs(this.seconds)>0){
					return parseInt(Math.abs(this.seconds)/60*100)
				}else{
					return 0
				}
			},
		},
		created() {
			this.getInquiryById(true);
			console.log(this.userInfo)

		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer); //关闭
			}
		},
		mounted() {
			let _this = this;
			// _this.$once('hook:beforeDestroy', () => {
			// 	clearInterval(_this.timer);
			// })
		},
		methods: {
			// 导出中标结果
			async exportTenderWord(){
				let _this = this;
				const {
					data: res
				} = await exportWord({id:_this.hId})
				// console.log(res)
				let blob = new Blob([res], {
					type: `application/msword` //word文档为msword,pdf文档为pdf，msexcel 为excel
				});
				let objectUrl = URL.createObjectURL(blob);
				let link = document.createElement("a");
				let fname = `物资采购项目评审报告.doc`; //下载文件的名字+后缀名
				link.href = objectUrl;
				link.setAttribute("download", fname);
				document.body.appendChild(link);
				link.click();
			},
			getCountDown(){
				let text = null;
				let info = this.xjOrder;
				if(info.bjEndTime && (info.orderState == 2 || info.gysOrderState == 3)){
					let diff = moment(info.bjEndTime).unix() - moment().unix();
					if(diff<=0){
						text = '0天0时0分'
					}else{
						text = this.timeStamp(diff)
					}
				}
				this.countDown = text
			},
			timeStamp( second_time ){
				var time = parseInt(second_time) + "秒";
				if( parseInt(second_time )> 60){
					var second = parseInt(second_time) % 60;
					var min = parseInt(second_time / 60);
					time = min + "分" + second + "秒";
					if( min > 60 ){
						min = parseInt(second_time / 60) % 60;
						var hour = parseInt( parseInt(second_time / 60) /60 );
						time = hour + "小时" + min + "分" + second + "秒";

						if( hour > 24 ){
							hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
							var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
							time = day + "天" + hour + "小时" + min + "分" + second + "秒";
						}
					}
				}
				return time;
			},
			// 编辑定标 type 1 编辑  2查看
			editTender(type){
				let _this = this;
				if(type == 1){
					// 查看当前是否有评委
					this.$refs.JudgeListRef.getJudgeList().then((JudgeList)=>{
						if(JudgeList.length>0){
							this.$refs.RoundListRef.editTenderInfo(type)
						}else{
							this.$fail('当前订单未指定评委，请先指定评委后再指定中标供方！')
						}
					});
				}else if(type == 2){
					this.$refs.RoundListRef.editTenderInfo(type)
				}else if(type == 3){	// 直接在物料行编辑
					// 查看当前是否有评委
					this.$refs.JudgeListRef.getJudgeList().then((JudgeList)=>{
						if(JudgeList.length>0){
							// 当前tab 编辑模式
							// _this.MateriaTableIsEditTender = true;

							// 用弹框编辑的模式 增大可操控视图面积
							// 获取列表的数据 回填到弹框部分
						  console.log(this.$refs.MateriaTableRef.showTableData)
							this.$refs.EditTenderRef.initDialog([
								...this.$refs.MateriaTableRef.showTableData,
							])
						}else{
							this.$fail('当前订单未指定评委，请先指定评委后再指定中标供方！')
						}
					});
				}else if(type == 4){	// 保存中标数据
					this.$refs.MateriaTableRef.saveTender()
				}else if(type == 5){	// 取消编辑中标数据
					_this.MateriaTableIsEditTender = false;
				}

			},
			// 新增轮次
			addRound(){
				this.$refs.RoundListRef.addRound()
			},
			// 新增附件
			addFile(){
				this.$refs.FileListRef.addFile()
			},
			addNotice(){
				console.log(this.$refs.NoticeListRef)
				this.$refs.NoticeListRef.addNotice()
			},
			// 新增评委
			addJudge(){
				this.$refs.JudgeListRef.addJudge()
			},
			// 物料模块定标回调
			MateriaTableCallback(obj){
				if(obj.type == 'tenderSuc'){
					if(obj.hasDatas){	// 弹框方式
						this.$refs.EditTenderRef.closeVisible()
					}else{	// 老的方式
						this.MateriaTableIsEditTender = false;
					}
					this.getInquiryById();
					this.$refs.MateriaTableRef.getList();
				}
			},
			// 创建轮次信息成功 保存回调 测试用
			roundListCallback(obj){
				if(obj.type == 'addround'){
					console.log(obj.data)
				}
				if(obj.type == 'updateInfo'){
					this.getInquiryById();
				}
				if(obj.type == 'isAgain'){
					this.isAgain = obj.isAgain;
				}
			},
			// 新增物料
			addMaterial(){
				this.$refs.MateriaTableRef.addMateria()
			},
			getInquiryById(isFirst) {
				let _this = this;
				inquiryById({
					id: _this.$route.query.hId
				}).then(response => {
					if (response.data.code === 0) {
						_this.xjOrder = response.data.data;
						console.log(_this.xjOrder)
						// 是否显示审批日志模块
						// if(_this.xjOrder.orderState >= 4 && (_this.checkRole('cgy_role') || _this.checkRole('leader') )){
						// 	_this.auditFlag = true;
						console.log('执行。。。。')
						console.log(_this.auditShow)
							if(_this.auditShow){
								_this.getAuditLog();
							}
						// }
						if(_this.timer){ clearInterval(_this.timer) }
						_this.timer = setInterval(function() {
							// _this.timeFn(_this.xjOrder.bjJzTime);
							_this.getCountDown()
						}, 1000);
						if(isFirst){
							if(this.checkRole('gys_role')){
								this.$nextTick(()=>{
									this.activeName = 'second'
								})
							}
							if(this.auditShow){
								this.getAuditState()
							}
						}
					}
				});
			},
			handleExport: function() {
				let _this = this;
				_this.confirm({
					text: '导出当前页，还是全部导出',
					but1: '全部导出',
					but2: '当前页',
					type: '',
					fn: function() {
						let param = JSON.parse(JSON.stringify(_this.quertInfo));
						param.page = 0;
						exportInquiryDetail(param).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					cancel: function() {
						exportInquiryDetail(_this.quertInfo).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			handleAvatarExcel(res, file) {
				if (res.code == 0) {
					this.getList();
				}
				this.loadingInstance.close();
				this.$success(res.msg);
			},
			beforeExcel(file) {
				// 判断文件后缀
				let type = file.name.substring(file.name.lastIndexOf('.') + 1);
				if (!(type == "xls" || type == "xlsx")) {
					this.$fail('请导入Excel文件');
					return false;
				}

				const isLt2M = file.size / 1024 / 1024 <= 1;
				if (!isLt2M) {
					this.$fail('导入Excel不能超过 1MB!');
					return false;
				}
				this.loadingInstance = this.Loading({
					text: '导入中请等待...'
				});
			},
			//参与价单
			handleCy: function() {
				let _this = this;
				joinInquiry({
					id: _this.xjOrder.inquiryUserId,
					inquiryId:_this.xjOrder.id,
				}).then(response => {
					if (response.data.code === 0) {
						_this.$success(response.data.msg);
						_this.getInquiryById();
					} else {
						_this.$fail(response.data.msg);
					}
				});
			},
			//放弃询价单
			handleFq: function() {
				let _this = this;
				_this.confirm({
					text: '是否确认放弃？',
					tip: '警告',
					type: '',
					fn: function(param) {
						giveUpInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getInquiryById();
							}
						});
					},
					data: { //参数对象 主要回调函数用
						id: _this.xjOrder.inquiryUserId,
						inquiryId:_this.xjOrder.id,
					 }
				});
			},
			formatDay: function(e) {
				return this.dayDiff + "天";
			},
			formatHours: function(e) {
				return this.hours + "时";
			},
			formatMins: function(e) {
				return this.minutes + "分";
			},
			formatSec: function(e) {
				return this.seconds + "秒";
			},
			timeFn: function(d1) { //di作为一个变量传进来
				if(!d1){
					return
				}
				let _this = this;
				//如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
				let dateBegin = new Date(d1.replace(/-/g, "/")); //将-转化为/，使用new Date
				let dateEnd = new Date(); //获取当前时间
				let dateDiff = dateBegin.getTime() - dateEnd.getTime(); //时间差的毫秒数
				_this.dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
				let leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
				_this.hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
				//计算相差分钟数
				let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
				_this.minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
				//计算相差秒数
				let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
				_this.seconds = Math.round(leave3 / 1000)
			},
			// 整单结束询价
			handleJsxu(){
				let _this = this;
				_this.confirm({
					text: '是否确认结束整单报价？',
					tip: '警告',
					type: '',
					fn: function(param) {
						finishOrderXj(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getInquiryById();
							}
						});
					},
					data: { //参数对象 主要回调函数用
						id: _this.xjOrder.id,
					 }
				});
			},
			// 发起审批
			startAuditOrder(){
				let _this = this;
				// 查看当前是否有评委
				this.$refs.JudgeListRef.getJudgeList().then((JudgeList)=>{
					if(JudgeList.length>0){
						auditOrder({
							auditStatus:3,
							id:_this.xjOrder.id
						}).then(({data:res}) => {
							if(res.code == 0){
								_this.$success('发起成功');
								_this.getInquiryById();
							}
						})
					}else{
						this.$fail('当前订单未指定评委，请先指定后再发起审批！')
					}
				});
			},
			openAuditOrder(){
				let _this = this;
				this.$refs.AuditTenderRef.auditOpen({id:_this.xjOrder.id})
			},
			AuditTenderRefCallback(obj){
				if(obj.type == 'updateInfo'){
					this.getInquiryById()
				}
			},
			// 编辑中标供方弹框 回调
			EditTenderRefCallback(obj){
				if(obj.type == 'close'){	// 关闭
					this.$refs.EditTenderRef.closeVisible()
				}
				if(obj.type == 'submit'){	// 提交
					this.$refs.MateriaTableRef.saveTender(obj.data)
				}
			},
			// 获取审批日志
			getAuditLog(){
				let _this = this;
				getOrderAuditListByOrderId({orderId:_this.xjOrder.id}).then(({data:res})=>{
					console.log(res);
					_this.auditList = res.data||[];
					if(_this.auditList.length >0 && (_this.checkRole('cgy_role') || _this.checkRole('pw') || _this.checkRole('leader') ) && this.auditShow){
						_this.auditFlag = true;	// 详情页面不显示审核记录
					}
				})
			},
			// 发送中标通知
			sendTenderMsg(){
				let _this = this;
				zhongbiaoOrderNotice({id:_this.xjOrder.id}).then(({data:res})=>{
					if(res.code == 0){
						_this.$success('发送成功');
						_this.getInquiryById()
					}
					// console.log(res);
					// _this.auditList = res.data||[];
				})
			},
			// 生成采购订单
			creatCGOrder(){
				let _this = this;
				generateFinalOrder({id:_this.xjOrder.id}).then(({data:res})=>{
					_this.$success('操作成功');
					_this.getInquiryById()
				})
			},
			// 获取审核状态
			getAuditState(){
				getLastOrderState({orderId:this.xjOrder.id}).then(({data:res})=>{
					console.log(res)
					this.lastAudit = res.data;
					// if(res.data == 5){
					// 	this.lastAudit = 6;
					// }
				})
			},
		},
		watch:{
			'activeName':function(nVal){
				this.MateriaTableIsEditTender = false;
				if(nVal == 'first'){
					if(this.showTenderRow){
						this.showTenderRow = false;
					}else{
						this.$refs.MateriaTableRef.getList();
					}
				}
				if(nVal == 'second'){
					this.$refs.RoundListRef.getInquiryRoundList();
				}
				if(nVal == 'third'){
					this.$refs.FileListRef.getFileList();
				}
				if(nVal == 'fourth'){
					this.$refs.JudgeListRef.getJudgeList();
				}
			}
		}
	};
</script>
<style scoped="scoped" lang="scss">
	.order-detail-page{
		.djs-bar{
			margin-left: 20px;
			font-weight: 700;
			color: red;
		}
		.el-steps--simple{
			padding:13px 10px;
		}
	}
	.order-info-main{
		width: 100%;
		display: flex;
		.info-wrap{
			width: 100%;
			&.has-audit-list{
				width: calc(100% - 310px);
			}
		}
		.audit-wrap{
			width: 300px;
			// display: none;
			// height: calc(100vh - 200px);
			/* background: #fff; */
			margin-left: 10px;
			margin-top: 0px;
			.audit-list-box{
                width: 100%;
				height: calc(100vh - 200px);
				overflow-y: auto;
                .audit-item{
                    margin-bottom: 30px;
					/* background: #eee; */
					border-bottom: 1px solid #e8e8e8;
                    .bar{
                        display: flex;
                        height: 40px;
                        justify-content: space-between;
						.name-box{
							.name{
								font-size: 14px;
								font-weight: 700;
								color: #333;
								line-height: 20px;
							}
							.time{
								font-size: 12px;
								color: #999;
								line-height: 20px;
							}
						}
                    }
					.audit-img{
						width: 100%;
						text-align: center;
						// margin: 10px 0;
						// padding: 10px;
						// text-align: justify;
						img{
							width: 50%;
						}
					}
                    .bh-reson{
                        width: calc(100% - 20px);
                        background: #eee;
                        text-align: justify;
                        padding: 10px;
                        margin: 10px 0;
						border-radius: 5px;
						font-size: 12px;
                    }
                }
            }
		}
	}
	.app-main-time {
		display: flex;
		flex-direction: row;
		text-align: center;
		justify-content: space-between;

	}
	.tab-pane-btns{
		height: 32px;
		position: absolute;
		right: 10px;
    	top: 5px;
		text-align: right;
		.show-tender-row-switch{
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			display: flex;
			.el-switch{
				margin-top: 6px;
			}
			span{
				line-height: 32px;
				margin-right: 10px;
			}
		}
	}
</style>
